import { useContext } from "react";
import { PortalStateContext } from "./PortalProvider";

export function usePortalState(name: string) {
  const { state } = useContext(PortalStateContext);

  return state[name] ?? [];
}